import { getHeaders } from "CommonUtils";
import axios from "axios";
import { getRequest, postRequest, patchRequest } from "NetworkCall";
import {
  APP_API_KEY,
  INSTANCE_URL,
  LOGIN,
  REGISTER,
  DEVELOPMENT_TYPE,
} from "Constants";
import {
  SESSION_TOKEN,
  USER_ID,
  REGISTER_OTP,
  ADMIN_USER_ID,
  USER_EMAIL,
  ACTION_LOGOUT,
} from "Actions";

export function guestSignup(callback) {
  var url = `${INSTANCE_URL}/api/v2/user/register?login=true`;

  var userid = generateUserID();
  var emailid = `guest${userid}@eventify.com`;

  var payload = {
    email: emailid,
  };
  var options = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var response = axios.post(url, payload, options);

  return (dispatch) => {
    response.then(({ data }) => {
      var sessionToken = data.session_token;
      // save the session token generated during registration
      dispatch({ type: SESSION_TOKEN, payload: data });

      // store the email id of the user
      dispatch({ type: USER_EMAIL, payload: emailid });

      // fetch the DF user id. DF user id is not returned during registration
      // It needs to be fetched sepatately using session
      var sessionUrl = `${INSTANCE_URL}/api/v2/user/session`;
      var sessionOptions = {
        headers: {
          "X-DreamFactory-Api-Key": APP_API_KEY,
          "X-DreamFactory-Session-Token": sessionToken,
          contentType: "application/json; charset=utf-8",
        },
      };
      var sessionResponse = axios.get(sessionUrl, sessionOptions);

      sessionResponse
        .then(({ data }) => {
          // save the DF user id under the reducer user
          dispatch({ type: USER_ID, payload: data.id });
          //dispatch({type: SIGNUP_STEP, payload: STEP_VERIFY});

          //var session={apiKey:APP_API_KEY,sessionToken:sessionToken};
          callback({ success: 1 });
        })
        .catch((error) => {
          callback({ success: 0, message: error });
        });
    });
  };
}

export function prefilledLogin(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/prefillGuestLogin`;
  var body = { ...values, developmenttype: DEVELOPMENT_TYPE };
  // var body = {
  //   userid:values.userid,
  //   email:values.email,
  //   timezone:values.timezone
  // };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response.result });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function scratchGuestLogin(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/scratchGuestLogin`;
  var body = { ...values, developmenttype: DEVELOPMENT_TYPE };
  // var body = {
  //   userid:values.userid,
  //   email:values.email,
  //   timezone:values.timezone
  // };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response.result });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

function generateUserID() {
  const min = 100000;
  const max = 999999;
  const random = Math.floor(min + Math.random() * (max - min));
  /*var length = 6,
  charset = "abcdefghijklmnopqrstuvwxyz0123456789",
  retVal = "";
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }*/
  var userID = random + "";
  return userID;
}
